import React from 'react';
import PropTypes from 'prop-types';
import Icon from '../../Icons/Icon';
import TimesCircle from '../../Icons/TimesCircle';
import WarningCircle from '../../Icons/WarningCircle';

const Alert = ({ type, ...props }) => {
    let icon;
    let borderColor;
    let textColor;

    switch (type) {
        case 'error':
            icon = <TimesCircle />;
            borderColor = 'border-red-600';
            textColor = 'text-red-600';
            break;
        case 'warning':
            icon = <WarningCircle />;
            borderColor = 'border-yellow-400';
            textColor = 'text-yellow-400';
            break;
        default:
            break;
    }

    return (
        <div
            className={`flex items-center px-4 py-3 space-x-3 text-sm leading-normal md:text-md font-medium text-gray-700 bg-white border-l-4 rounded shadow ${borderColor}`}
            role='alert'>
            {icon && (
                <div className={`stroke-2 flex-none w-7 ${textColor}`}>
                    <Icon type={icon} />
                </div>
            )}
            <div>{props.children}</div>
        </div>
    );
};

Alert.propTypes = {
    type: PropTypes.string.isRequired,
};

export default Alert;
